export default {
    jdLable: "Job Description",
    textAreaPlaceHolder: 'Paste your job description here',
    placeholderText: 'Copy and paste the JD here',
    or: 'or',
    selectJdLabel: 'Select from saved job description',
    textAreaPLaceholderText: 'Enter job description here / Select job description from above'
}